module.exports = __webpack_public_path__ + "static/assets/edf5571fc769a213bbbac59c1d03340f.png";